import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { UI_MODE, UI_MODE_COPY, UI_MODE_ICON } from 'framework-listing-lib/constants/uiMode';
import useUIMode, { useUIModes } from 'framework-listing-lib/internal/hooks/useUIMode';
import { useHasViews } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function useUIModeSelectOptions() {
  const {
    currentUIMode
  } = useUIMode();
  const uiModes = useUIModes();
  const hasViews = useHasViews();
  const displayedUIModes = useMemo(() => uiModes.filter(uiMode => uiMode !== UI_MODE.FOLDERS), [uiModes]);
  const shouldDisplaySelect = useMemo(() => hasViews && currentUIMode !== UI_MODE.FOLDERS && displayedUIModes.length > 1, [currentUIMode, hasViews, displayedUIModes.length]);
  const uiModeOptions = useMemo(() => {
    if (!shouldDisplaySelect) {
      return [];
    }
    return displayedUIModes.map(uiMode => {
      const option = {
        value: uiMode,
        text: I18n.text(UI_MODE_COPY[uiMode]),
        icon: UI_MODE_ICON[uiMode]
      };
      if (uiMode === UI_MODE.GALLERY) {
        option.dropdownText = /*#__PURE__*/_jsxs(Flex, {
          display: "inline-flex",
          alignItems: "center",
          gap: "200",
          children: [option.text, /*#__PURE__*/_jsx(Badge, {
            use: "new",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "frameworkListingLib.editColumnsModal.newBadge"
            })
          })]
        });
      }
      return option;
    });
  }, [displayedUIModes, shouldDisplaySelect]);
  return useMemo(() => {
    return {
      uiModeOptions,
      shouldDisplaySelect
    };
  }, [uiModeOptions, shouldDisplaySelect]);
}